import axios from "axios";
import { getApiKey, getTeamEmail, getToken, isAutoAuthPending, removeApiKey, removeTeamEmail, removeToken } from "../Utility/Utility";

export const getBaseURL = () => {
  if (process.env.REACT_APP_SUBSCRIPTION_API_URL) {
    return process.env.REACT_APP_SUBSCRIPTION_API_URL;
  }

  if (process.env.NODE_ENV === "development") {
    return "http://localhost:8011/api";
  }

  return `${window.location.origin}/api`;
};

export const getBackendOrigin = () => {
  const base = getBaseURL();
  try {
    if (/^https?:\/\//i.test(base)) {
      const u = new URL(base);
      return `${u.protocol}//${u.host}`;
    }
  } catch (e) { /* ignore */ }
  return window.location.origin;
};

export const toAbsoluteBackendUrl = (relativeOrAbsolute) => {
  if (!relativeOrAbsolute) return '';
  if (/^https?:\/\//i.test(relativeOrAbsolute)) return relativeOrAbsolute;
  const origin = getBackendOrigin();
  const normalized = relativeOrAbsolute.startsWith('/') ? relativeOrAbsolute : `/${relativeOrAbsolute}`;
  return `${origin}${normalized}`;
};
  
// Create Axios Instance
const apiClient = axios.create({
  baseURL: getBaseURL(),
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});


// Request Interceptor (Attach Token)
apiClient.interceptors.request.use((config) => {
  const token = getToken("token");
  const apiKey = getApiKey();
  const teamEmail = getTeamEmail();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (apiKey) {
    config.headers['x-api-key'] = apiKey;
    if (teamEmail) {
      config.headers['x-team-email'] = teamEmail;
    }
  }

  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
}, (error) => Promise.reject(error));

// Response Interceptor (Handle Errors)
apiClient.interceptors.response.use(
  (response) => response && response.data,
  (error) => {
    console.error("API Error:", error.response?.data?.message || error.message);
    if (error.response?.status === 401) {
      if (isAutoAuthPending()) {
        return Promise.reject(error);
      }
      removeToken();
      removeApiKey();
      removeTeamEmail();
      if (
        !window.location.pathname.startsWith('/login') &&
        !window.location.pathname.startsWith('/team-login') &&
        !window.location.pathname.startsWith('/register') &&
        !window.location.pathname.startsWith('/embed')
      ) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
